module.exports = __webpack_public_path__ + "NumericaLogo.png";